var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4720_44445",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4720_44445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 19.5827V17.0827H26.25V19.5827H13.75ZM13.75 12.916V10.416H26.25V12.916H13.75ZM10 23.7493H22.5C23.25 23.7493 23.9378 23.9088 24.5633 24.2277C25.1878 24.5477 25.7222 24.9994 26.1667 25.5827L30 30.5827V7.16602C30 7.02713 29.9517 6.90879 29.855 6.81102C29.7572 6.71435 29.6389 6.66602 29.5 6.66602H10.5C10.3611 6.66602 10.2433 6.71435 10.1467 6.81102C10.0489 6.90879 10 7.02713 10 7.16602V23.7493ZM10.5 33.3327H28.9583L24.2083 27.1243C23.9861 26.8466 23.7289 26.631 23.4367 26.4777C23.1456 26.3255 22.8333 26.2493 22.5 26.2493H10V32.8327C10 32.9716 10.0489 33.0899 10.1467 33.1877C10.2433 33.2844 10.3611 33.3327 10.5 33.3327ZM29.5 35.8327H10.5C9.66667 35.8327 8.95833 35.541 8.375 34.9577C7.79167 34.3744 7.5 33.666 7.5 32.8327V7.16602C7.5 6.33268 7.79167 5.62435 8.375 5.04102C8.95833 4.45768 9.66667 4.16602 10.5 4.16602H29.5C30.3333 4.16602 31.0417 4.45768 31.625 5.04102C32.2083 5.62435 32.5 6.33268 32.5 7.16602V32.8327C32.5 33.666 32.2083 34.3744 31.625 34.9577C31.0417 35.541 30.3333 35.8327 29.5 35.8327Z",
    fill: "#EB6D47"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabProfile);
export default __webpack_public_path__ + "static/media/lab_profile.40c8ee5a90bc5d518c6ca8b0a32531dd.svg";
export { ForwardRef as ReactComponent };